import React from 'react';
import { normalizeUrlFactory } from '../../../../extensions/markdown';
import { fileType } from '../../../../extensions/yfm';
import { ReactWidgetDescriptor, removeDecoration } from '../../WidgetDecoration';
import { YfmFilesUploadProcessBase } from '../YfmFilePaste/upload';
import { FilePlaceholder } from './view';
export const addWidget = (tr, deps, uploadFiles) => {
    return new FileWidgetDescriptor(tr.selection.from, deps, uploadFiles).applyTo(tr);
};
export const removeWidget = removeDecoration;
class FileWidgetDescriptor extends ReactWidgetDescriptor {
    constructor(initPos, deps, uploadFiles) {
        super(initPos, 'file_placeholder');
        this.widgetHandler = null;
        this.uploadFiles = uploadFiles;
        this.domElem = document.createElement('span');
        this.deps = deps;
    }
    getWidgetHandler(view, getPos) {
        if (!this.widgetHandler) {
            this.widgetHandler = new FileWidgetHandler({
                view,
                getPos,
                decoId: this.id,
                uploadFiles: this.uploadFiles,
            }, this.deps);
        }
        return this.widgetHandler;
    }
    getDomElem() {
        return this.domElem;
    }
    renderReactElement(view, getPos) {
        return this.getWidgetHandler(view, getPos).renderWidgetView(view, getPos);
    }
    remove() {
        super.remove();
        this.widgetHandler = null;
    }
}
class FileWidgetHandler {
    constructor({ decoId, view, getPos, uploadFiles }, deps) {
        this.onCancel = () => {
            this.view.dispatch(removeDecoration(this.view.state.tr, this.decoId));
            this.view.focus();
        };
        this.onSubmit = (params) => {
            var _a;
            if (!params.src || !params.name)
                return;
            const href = (_a = this.normalizeUrl(params.src)) === null || _a === void 0 ? void 0 : _a.url;
            const download = params.name;
            if (!href)
                return;
            const node = fileType(this.view.state.schema).create({ href, download });
            this.insertNodes([node]);
        };
        this.onAttach = async (files) => {
            if (!this.uploadFiles)
                return;
            const { view } = this;
            new YfmFileWidgetUploadProcess(view, files, this.uploadFiles, this.getPos()).run();
            view.dispatch(removeWidget(view.state.tr, this.decoId));
            view.focus();
        };
        this.decoId = decoId;
        this.view = view;
        this.getPos = getPos;
        this.uploadFiles = uploadFiles;
        this.normalizeUrl = normalizeUrlFactory(deps);
    }
    renderWidgetView(view, getPos) {
        this.view = view;
        this.getPos = getPos;
        return (React.createElement(FilePlaceholder, { onCancel: this.onCancel, onSubmit: this.onSubmit, onAttach: this.uploadFiles && this.onAttach }));
    }
    insertNodes(fileNodes) {
        let tr = this.view.state.tr;
        tr = tr.insert(tr.mapping.map(this.getPos()), fileNodes);
        tr = removeWidget(tr, this.decoId);
        this.view.dispatch(tr);
        this.view.focus();
    }
}
class YfmFileWidgetUploadProcess extends YfmFilesUploadProcessBase {
    constructor(view, files, uploadHandler, position) {
        super(view, files, uploadHandler);
        this.skeletonInitPos = position;
    }
    getSkeletonInitPos() {
        return this.skeletonInitPos;
    }
}
